import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {OwnershipTransferPrivateSellerStep, ServiceType, MessageContent} from './Constant/Constant';
import {
  setCurrentStep,
  setShowPopUp,
  resetState,
  setSelectedServiceType,
  createWorkOrder,
  setGeneralMessage,
} from './OwnershipTransferSellerSlice';
import {saveToHistory} from '../OwnershipTransferBlock/OwnershipTransferSlice';
import Popup from '../../Shared/Popup/PopUp';
import OwnershipTransferSellerPopupWrapper from './Popup/OwnershipTransferSellerPopupWrapper';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import OwnershipTransferSellerMain from './OwnershipTransferSellerMain';
import {getSelfCareData} from '../../Page/SelfCarePage/SelfCareAsyncThunk';
import {hideAppLoader, showAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';

const OwnershipTransferSeller = (props) => {
  useEffect(() => {
    return () => {
      props.hideAppLoader();
      props.resetState();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.data.currentStep]);

  //   useExtendedEffect((runSideEffects) => {
  //     if (runSideEffects()) {
  useEffect(() => {
    if (!props.data.currentStep) {
      if (props.authentication.isAuthenticateFinish && props.productsAndServices.productsBySubscriber != null) {
        getNextStep();
      } else {
        props.showAppLoader();
        if (props.productsAndServices.productsBySubscriber == null) {
          props.getSelfCareData();
        }
      }
    }
  }, [props.authentication, props.productsAndServices]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (!props.loader.isLoading) {
          const timeoutId = setTimeout(() => {
            props.saveToHistory(props.data.currentStep);
          }, 1500);
          return () => clearTimeout(timeoutId); //  Cleanup to prevent memory leaks
        }
      }
    },
    [props.data.currentStep, props.loader.isLoading],
  );

  useClearStateResetFlag();

  function getNextStep() {
    if (props.productsAndServices.selfCareData.coreProducts.length > 0) {
      if (props.productsAndServices.selfCareData.coreProducts.includes('Cellular')) {
        if (
          props.productsAndServices.selfCareData.coreProducts.includes('TV') ||
          props.productsAndServices.selfCareData.coreProducts.includes('Internet') ||
          props.productsAndServices.selfCareData.coreProducts.includes('InternetIsp') ||
          props.productsAndServices.selfCareData.coreProducts.includes('Mapa')
        ) {
          props.setCurrentStep(OwnershipTransferPrivateSellerStep.SelectServiceType);
        } else {
          props.setSelectedServiceType(ServiceType.Cellular);
          props.setCurrentStep(OwnershipTransferPrivateSellerStep.SelectCellularNumber);
        }
      } else if (!props.productsAndServices.selfCareData.coreProducts.includes('Cellular')) {
        props.setSelectedServiceType(ServiceType.StationaryLine);
        props.setCurrentStep(OwnershipTransferPrivateSellerStep.SelectStationaryLineType);
      }
    } else {
      props.setGeneralMessage(MessageContent.GeneralError);
      props.setCurrentStep(OwnershipTransferPrivateSellerStep.GeneralMessage);
    }
    props.hideAppLoader();
  }

  function createWorkOrder() {
    const SelectedProduct = {
      SubscriberNo: props.data.serviceToTransfer.subscriberNumber,
      AssetExternalId: props.data.serviceToTransfer.assetExternalId,
    };
    const orderData = {
      SelectedProduct,
      FailReason: props.data.failReason,
    };
    props.createWorkOrder(orderData);
  }

  return (
    <div className='ownershipTransferPrivate ownershipTransfer'>
      <OwnershipTransferSellerMain iContent={props.iContent} createWorkOrder={createWorkOrder} getNextStep={getNextStep} />
      <Popup className='mainPopup MessagePopup' showPopUp={props.data.showPopup} onClose={() => props.setShowPopUp(false)}>
        <OwnershipTransferSellerPopupWrapper iContent={props.iContent} createWorkOrder={createWorkOrder} />
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateSeller,
  productsAndServices: state.selfcarePage,
  authentication: state.authentication,
  loader: state.loader,
});

const mapDispatchToProps = {
  resetState,
  setCurrentStep,
  saveToHistory,
  setShowPopUp,
  showAppLoader,
  hideAppLoader,
  getSelfCareData,
  setSelectedServiceType,
  createWorkOrder,
  setGeneralMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferSeller);
